import { supabase } from '../lib/supabase';

const TABLE_NAME = 'companies';

// Get all companies
export const getCompanies = async () => {
  const { data, error } = await supabase
    .from(TABLE_NAME)
    .select('*')
    .order('name', { ascending: true });

  if (error) throw error;
  return data || [];
};

// Get single company by ID
export const getCompany = async (id) => {
  const { data, error } = await supabase
    .from(TABLE_NAME)
    .select('*')
    .eq('id', id)
    .single();

  if (error) throw error;
  return data;
};

// Search companies by name (for search dropdown)
export const searchCompanies = async (searchTerm, limit = 10) => {
  if (!searchTerm || searchTerm.trim() === '') {
    return [];
  }

  const { data, error } = await supabase
    .from(TABLE_NAME)
    .select('*')
    .ilike('name', `%${searchTerm}%`)
    .limit(limit)
    .order('name', { ascending: true });

  if (error) throw error;
  return data || [];
};

// Get company with associated clients (using company_id)
export const getCompanyWithClients = async (id) => {
  // First get the company
  const { data: company, error: companyError } = await supabase
    .from(TABLE_NAME)
    .select('*')
    .eq('id', id)
    .single();

  if (companyError) throw companyError;
  if (!company) return null;

  // Then get clients linked by company_id
  const { data: clients, error: clientsError } = await supabase
    .from('clients')
    .select('*')
    .eq('company_id', id)
    .order('name', { ascending: true });

  if (clientsError) throw clientsError;

  return {
    ...company,
    clients: clients || []
  };
};

// Create new company
export const createCompany = async (companyData) => {
  const { data, error } = await supabase
    .from(TABLE_NAME)
    .insert([companyData])
    .select()
    .single();

  if (error) throw error;
  return data;
};

// Update company
export const updateCompany = async (id, companyData) => {
  const { data, error } = await supabase
    .from(TABLE_NAME)
    .update(companyData)
    .eq('id', id)
    .select()
    .single();

  if (error) throw error;
  return data;
};

// Delete company (sets clients.company_id to null via foreign key constraint)
export const deleteCompany = async (id) => {
  // First, set all clients' company_id to null
  const { error: updateError } = await supabase
    .from('clients')
    .update({ company_id: null })
    .eq('company_id', id);

  if (updateError) throw updateError;

  // Then delete the company
  const { error } = await supabase
    .from(TABLE_NAME)
    .delete()
    .eq('id', id);

  if (error) throw error;
};

// Get clients for a company
export const getClientsByCompany = async (companyId) => {
  const { data, error } = await supabase
    .from('clients')
    .select('*')
    .eq('company_id', companyId)
    .order('name', { ascending: true });

  if (error) throw error;
  return data || [];
};
